export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'success';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonClassOptions {
  variant: ButtonVariant;
  size: ButtonSize;
  iconOnly?: boolean;
  fullWidth?: boolean;
}

/** Pure class list builder for `app-button` / `.btn*`. */
export function buildButtonClasses(options: ButtonClassOptions): string {
  const classes = ['btn'];

  if (options.variant === 'primary') {
    classes.push('btn-primary');
  } else if (options.variant === 'danger') {
    classes.push('btn-danger');
  } else if (options.variant === 'ghost') {
    classes.push('btn-ghost');
  } else if (options.variant === 'success') {
    classes.push('btn-success');
  } else {
    classes.push('btn-secondary');
  }

  if (options.size === 'sm') {
    classes.push('btn-sm');
  } else if (options.size === 'lg') {
    classes.push('btn-lg');
  }

  if (options.iconOnly) {
    classes.push('btn-icon', 'tt-icon-btn');
  }

  if (options.fullWidth) {
    classes.push('w-full');
  }

  return classes.join(' ');
}
